module.exports = __webpack_public_path__ + "static/media/dashboard-icon.298dd401.svg";